import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarker, faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { toast } from "react-toastify";
import { Card } from "react-bootstrap";
import { openCustomModal, closeCustomModal } from "views/lib/components/modals";
import filterTypes from "data/filter-types";
import Loading from "views/lib/Loading";
import { search, finish } from "actions/scooter/trip-active/actions";
import { getList } from "actions/scooter/scooter/actions";

import MapPosition from "./map-position";
import FinishTripModal from "./finish-trip-modal";
import getFilesUrl from "../../../../helpers/getFilesUrl";
import avatarPlaceholder from "../../../../images/avatar.png";

const ScooterTripActiveView = ({
                                 list,
                                 search,
                                 finish,

                                 getScooter,
                                 scooterItemList,
                                 ...rest
                               }) => {
  const [loading, setLoading] = useState(true);

  const { id } = rest.match.params;
  const item = list && list.content && list.content[0];
  const scooterItem = scooterItemList && scooterItemList.content && scooterItemList.content[0]
    ? scooterItemList.content[0]
    : false;

  const handleOpenMap = (position) => {
    if (!position || !Object.keys(position).length) {
      toast("Coordinates not available", {
        type: toast.TYPE.ERROR,
      });
      return null;
    }
    const modalObj = {
      id: "trip-active-position",
      modalSettings: {
        size: "sm"
      },
      header: "Trip position",
      children: (
        <MapPosition
          coordinates={[position.longitude, position.latitude]}
          onCancel={() => rest.closeCustomModal(modalObj)}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization"
          loadingElement={<div style={{ height: "100%" }}/>}
          containerElement={<div style={{ height: 400 }}/>}
          mapElement={<div style={{ height: "100%" }}/>}
        />
      ),
      handleClose: () => rest.closeCustomModal(modalObj)
    };
    rest.openCustomModal(modalObj);
  };

  const handleFinish = () => {
    const modalObj = {
      id: "trip-finish-modal",
      modalSettings: {
        size: "sm"
      },
      header: "Finish Trip",
      children: (
        <FinishTripModal
          id={id}
          callback={() => {
            rest.closeCustomModal(modalObj);
          }}
          onCancel={() => rest.closeCustomModal(modalObj)}
        />
      ),
      handleClose: () => rest.closeCustomModal(modalObj)
    };
    rest.openCustomModal(modalObj);
  };

  useEffect(() => {
    search(0, 1, "id,ASC", [{
      fieldName: "id",
      fieldValue: id,
      searchOperation: filterTypes.EQUALS.value
    }]);
  }, [search, id]);

  useEffect(() => {
    if (item) {
      getScooter(0, 1, "id,ASC", [{
        fieldName: "id",
        fieldValue: item.scooter,
        searchOperation: filterTypes.EQUALS.value
      }]);
      setLoading(false);
    }
  }, [item, getScooter]);

  if (loading) {
    return <Loading state={loading}/>;
  }

  const pauses = (item && item.pauses) || [];
  const speedChanges = (item && item.speedChanges) || [];

  /*
  photo: null
   */
  return (
    <div className="m-2 position-relative">
      <Card className="rounded-0">
        <Card.Header>
          <div className="d-inline-flex align-items-center">
            Scooter Active Trip
          </div>
        </Card.Header>
        <Card.Body>
          <table className="table table-bordered table-hover">
            <tbody>
            <tr>
              <th>ID</th>
              <td>{item.id}</td>
            </tr>
            <tr>
              <th>Image</th>
              <td>
                {item && item.photo ? (
                  <a href={getFilesUrl(item.photo)} target="_blank" rel="noopener noreferrer">
                    <img src={item.photo
                      ? getFilesUrl(item.photo)
                      : avatarPlaceholder}
                         alt={`Trip: ${item.id}`}
                         className="img-thumbnail w-auto"
                    />
                  </a>
                ) : "Image not exists"}
              </td>
            </tr>
            <tr>
              <th>State</th>
              <td>{item.state}</td>
            </tr>
            <tr>
              <th>User</th>
              <td>
                <Link to={`/users/${item.user}`}>
                  {item.user}
                </Link>
              </td>
            </tr>
            <tr>
              <th>Amount</th>
              <td>{item.amount}</td>
            </tr>
            <tr>
              <th>Distance</th>
              <td>{item.distance}</td>
            </tr>
            <tr>
              <th>Scooter</th>
              <td>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    ID: <Link to={`/scooter/scooter/${item.scooter}`}>{item.scooterQr || item.scooter}</Link>
                  </div>
                  <div>QR: {scooterItem ? scooterItem.qr : "Loading..."}</div>
                  <div>
                    Current Position: {scooterItem ? (
                    <button
                      className="btn btn-sm btn-success"
                      onClick={() => handleOpenMap(scooterItem.located)}
                      title="Current Position"
                    >
                      <FontAwesomeIcon icon={faMapMarker}/>
                    </button>
                  ) : null}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>Scan Date</th>
              <td>
                {moment(item.scan)
                  .format("HH:mm YYYY-MM-DD")}
              </td>
            </tr>
            <tr>
              <th>Start - End Date</th>
              <td>
                {moment(item.start)
                  .format("HH:mm YYYY-MM-DD")}
                {" - "}
                {item.end ? moment(item.end)
                  .format("HH:mm YYYY-MM-DD") : "...continuous"}
              </td>
            </tr>
            <tr>
              <th>Start - End Millage</th>
              <td>
                {item.startMileage} - {item.endMileage || "Not calculated yet"}
              </td>
            </tr>
            <tr>
              <th>Start - End Position</th>
              <td>
                <button
                  className="btn btn-sm btn-success"
                  onClick={() => handleOpenMap(item.startPosition)}
                  title="Start position"
                >
                  <FontAwesomeIcon icon={faMapMarker}/> Start
                </button>
                {" - "}
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleOpenMap(item.startPosition)}
                  title="End position"
                  disabled={!item.endPosition}
                >
                  <FontAwesomeIcon icon={faMapMarker}/> {item.endPosition ? "End" : "...continuous"}
                </button>
              </td>
            </tr>
            <tr>
              <th>Speed Mode Tariff</th>
              <td>
                {item.speedModeTariff ? (
                  <table className="table table-secondary table-hover m-0 border-0">
                    <thead>
                    <tr>
                      <th>ID</th>
                      <th>Price</th>
                      <th>Speed Mode</th>
                      <th>Speed</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>{item.speedModeTariff.id}</td>
                      <td>{item.speedModeTariff.price}</td>
                      <td>{item.speedModeTariff.speedMode}</td>
                      <td>{item.speedModeTariff.speed}</td>
                    </tr>
                    </tbody>
                  </table>
                ) : "Not information"}
              </td>
            </tr>
            <tr>
              <th>Billing Mode Tariff</th>
              <td>
                {item.billingModeTariff ? (
                  <table className="table table-secondary table-hover m-0 border-0">
                    <thead>
                    <tr>
                      <th>ID</th>
                      <th>Price</th>
                      <th>Mode</th>
                      <th>Minutes</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>{item.billingModeTariff.id}</td>
                      <td>{item.billingModeTariff.price}</td>
                      <td>{item.billingModeTariff.mode}</td>
                      <td>{item.billingModeTariff.minutes}</td>
                    </tr>
                    </tbody>
                  </table>
                ) : "Not information"}
              </td>
            </tr>
            <tr>
              <th>Actions</th>
              <td>
                <button
                  className="btn btn-sm btn-warning"
                  title="Finish"
                  onClick={handleFinish}
                >
                  <FontAwesomeIcon icon={faCheckSquare}/> Finish
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </Card.Body>
      </Card>


      <Card className="rounded-0">
        <Card.Header>
          Speed Changes
        </Card.Header>
        <Card.Body>
          <table className="table table-bordered table-hover">
            <thead>
            <tr>
              <th>Start</th>
              <th>End</th>
              <th className="p-0 border-0">
                <table className="table table-secondary m-0">
                  <thead>
                  <tr>
                    <th colSpan={4}>Speed Mode Tariff</th>
                  </tr>
                  <tr>
                    <th width="40%">ID</th>
                    <th width="20%">Price</th>
                    <th width="20%">Speed Mode</th>
                    <th width="20%">Speed</th>
                  </tr>
                  </thead>
                </table>
              </th>
            </tr>
            </thead>
            <tbody>
            {([...speedChanges, ...pauses])
              .sort((a, b) => a.start - b.start)
              .map((speedChange, index) => (
                <tr key={index}>
                  <td>{speedChange.start ? moment(speedChange.start)
                    .format("HH:mm:ss DD/MM/YYYY") : "No Information"}</td>
                  <td>{speedChange.end ? moment(speedChange.end)
                    .format("HH:mm:ss DD/MM/YYYY") : "No Information"}</td>
                  {speedChange.speedModeTariffDetails && speedChange.speedModeTariffDetails.id ? (
                    <td className="p-0">
                      <table className="table table-secondary table-hover m-0">
                        <tbody>
                        <tr>
                          <td width="40%"
                              className="border-top-0 border-bottom-0">{speedChange.speedModeTariffDetails.id}</td>
                          <td width="20%"
                              className="border-top-0 border-bottom-0">{speedChange.speedModeTariffDetails.price}</td>
                          <td width="20%"
                              className="border-top-0 border-bottom-0">{speedChange.speedModeTariffDetails.speedMode}</td>
                          <td width="20%"
                              className="border-top-0 border-bottom-0">{speedChange.speedModeTariffDetails.speed}</td>
                        </tr>
                        </tbody>
                      </table>
                    </td>
                  ) : <td>Pause</td>}
                </tr>
              ))}
            </tbody>
          </table>
        </Card.Body>
      </Card>
    </div>
  );
};

const mapStateToProps = state => ({
  list: state.scooterTripActive.list,
  scooterItemList: state.scooter.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  search: bindActionCreators(search, dispatch),
  finish: bindActionCreators(finish, dispatch),

  getScooter: bindActionCreators(getList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ScooterTripActiveView);



// WEBPACK FOOTER //
// ./src/views/pages/scooter/trip-active/view.js